import { useTranslation } from 'react-i18next';
import { PromoCodeType } from 'models/PromoCode';

import Loader from 'components/loader/Loader';
import PageHeader from 'components/pageHeader/PageHeader';
import FormWithProvider from 'components/forms/form/Form';
import useFetchAllPropertiesForPromoCodes from '../useFetchAllPropertiesForPromoCodes';
import { Container } from './AddPromoCode.styles';
import AddForm from './addForm/AddForm';
import addPromoCodeSchema from './addForm/AddForm.schema';
import useAddPromoCodeFormSubmit from './useAddPromoCodeFormSubmit';

const AddPromoCode = () => {
  const { handleSubmit, isCreatingPromoCode } = useAddPromoCodeFormSubmit();
  const { t } = useTranslation();
  const { isPropertiesLoading, properties } =
    useFetchAllPropertiesForPromoCodes();

  if (isPropertiesLoading) {
    return <Loader fullPage />;
  }

  return (
    <>
      {isCreatingPromoCode && <Loader fullPage overlay />}
      <Container>
        <PageHeader
          title={t('pageDiscountCodes.pageAddDiscount.addDiscountCodeHeader')}
        />
        <FormWithProvider
          schema={addPromoCodeSchema}
          defaultValues={{
            type: PromoCodeType.AMOUNT,
            propertyUid: '',
            value: 0,
          }}
          horizontal
          onSubmit={handleSubmit}
        >
          <AddForm properties={properties ?? []} />
        </FormWithProvider>
      </Container>
    </>
  );
};

export default AddPromoCode;
